import React from "react";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import CategoryIcon from "@mui/icons-material/Category";

const CategorySelectButton = ({ count = 0, onClick }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      className="w-full"
      startIcon={
        count > 0 ? (
          <Badge badgeContent={count} color="primary">
            <CategoryIcon />
          </Badge>
        ) : (
          <CategoryIcon />
        )
      }
    >
      {count > 0 ? `${count} Categories Selected` : "Select Categories"}
    </Button>
  );
};

export default CategorySelectButton;
